package com.milta.feature.auth.domain.entity

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class UserRole(val apiValue: String) {
    @SerialName("Driver") DRIVER("Driver"),
    @SerialName("Enterprise") ENTERPRISE("Enterprise"),
}
